import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store'; // now exports configureStore instance
import ChuzeatWebApp from './app';
import './index.scss';
import './firebase';

ReactDOM.render(
  <Provider store={store}>
    <ChuzeatWebApp />
  </Provider>,
  document.getElementById('root')
);
